import Vue from 'vue';

export default {
	getJobs({ state, commit }, payload) {
		const queryParams = {
			page: payload.hasOwnProperty('page') ? payload.page : state.jobs.meta.current_page,
			limit: payload.hasOwnProperty('limit') ? payload.limit : state.jobs.meta.per_page,
		};

		return Vue.prototype.$http.get('/api/v1/jobs', {
			params: queryParams,
		})
			.then(response => {
				commit('setJobs', response.data);
			})
			.catch(error => {
				throw error;
			});
	},
};
